export const NAV_ACTIONS = {
  SET_MAIN: 'SET_MAIN',
  SET_SUB: 'SET_SUB',
};
